import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { GetAllFilter, SortDirection } from '../models/get-all-filter.model';

@Injectable({
  providedIn: 'root',
})
export class FilterService {
  sort: MatSort;
  page: PageEvent;
  filterExpression = '';
  filterColumn = '';

  clear() {
    this.sort = undefined;
    this.page = undefined;
    this.filterExpression = '';
    this.filterColumn = '';
  }

  generateHttpParams(take: number = 5): HttpParams {
    const generatedFilter = this.getFilter(take);

    let params = new HttpParams();

    if (!!generatedFilter) {
      if (generatedFilter.pageIndex !== null) {
        params = params.append(
          'pageIndex',
          generatedFilter.pageIndex.toString()
        );
      }

      if (generatedFilter.take !== null) {
        params = params.append('take', generatedFilter.take.toString());
      }

      if (!!generatedFilter.sortColumn) {
        params = params.append('sortColumn', generatedFilter.sortColumn);
        params = params.append(
          'sortDirection',
          generatedFilter.sortDirection.toString()
        );
      }

      if (!!generatedFilter.filterExpression) {
        params = params.append(
          'filterExpression',
          generatedFilter.filterExpression
        );
      }

      if (!!generatedFilter.filterColumn) {
        params = params.append('filterColumn', generatedFilter.filterColumn);
      }
    }

    return params;
  }

  getFilter(take: number = 10): GetAllFilter {
    const newFilter = new GetAllFilter();
    if (!this.page) {
      this.page = new PageEvent();
      this.page.pageIndex = 0;
      this.page.pageSize = take;
    }

    newFilter.pageIndex = this.page.pageIndex;
    newFilter.take = this.page.pageSize;

    if (!!this.sort && !!this.sort.active && this.sort.direction !== '') {
      newFilter.sortDirection =
        this.sort.direction === 'asc' ? SortDirection.ASC : SortDirection.DESC;
      newFilter.sortColumn = this.sort.active.substr(
        this.sort.active.indexOf('_') + 1,
        this.sort.active.length - this.sort.active.indexOf('_') + 1
      );
    }

    if (!!this.filterExpression) {
      newFilter.filterExpression = this.filterExpression;
    }

    if (!!this.filterColumn) {
      newFilter.filterColumn = this.filterColumn;
    }

    return newFilter;
  }
}
